// Собирается Rollup в assets/built/index.js (+ извлекается CSS).

// Import CSS
import "../css/index.css";

// Import JS
import mobileMenu from "./mobileMenu";
import toc from "./toc";
import share from "./share";

mobileMenu();
toc();
share();
